import { Box, BoxProps } from '@mui/material';

function FlyImage(props: BoxProps<'img'>) {
  return <Box {...props} component="img" />;
}

export default FlyImage;
